import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { useParagraphMotion } from './motion/paragraph'
import { cn } from '@/lib/utils'

export type DoubleParagraphProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    pretitle: string
    title: string
    paragraph_1: string
    paragraph_2: string
  }>

const DoubleParagraph = ({
  pretitle,
  title,
  paragraph_1,
  paragraph_2,
  ...props
}: DoubleParagraphProps) => {
  const { motionRef } = useParagraphMotion()

  return (
    <Section ref={motionRef} {...props}>
      <Container>
        <Grid className="gap-y-[5rem] md:gap-y-[10rem]">
          {pretitle || title ? (
            <Grid className="col-span-2 md:col-span-6 lg:col-span-12">
              <div className={cn('col-span-2 md:col-span-3', 'grid gap-y-[3rem]')}>
                {pretitle ? (
                  <Typography variant="upper-small" component="h3" className="font-bold uppercase">
                    {pretitle}
                  </Typography>
                ) : null}

                {title ? (
                  <Typography variant="main-title-default" component="h2">
                    {title}
                  </Typography>
                ) : null}
              </div>
            </Grid>
          ) : null}

          <div className="col-span-2 md:col-span-3 lg:col-span-5">
            {paragraph_1 ? (
              <Typography variant="standard" paragraph className="" data-motion-paragraph>
                {paragraph_1}
              </Typography>
            ) : null}
          </div>

          <div className="col-span-2 md:col-span-3 lg:col-span-6 lg:col-start-7">
            {paragraph_2 ? (
              <Typography variant="standard" paragraph className="" data-motion-paragraph>
                {paragraph_2}
              </Typography>
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default DoubleParagraph
